"use client";
import image from "@/constants/image";
import { APP_ROUTES } from "@/constants/routes";
import { Box } from "@mui/material";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";

const HeaderAuth = () => {
  const locale = useLocale();
  return (
    <header className="mt-1 sm:mt-0 flex flex-col bg-gradient-to-b from-[#E9F2FB] via-[#E9F2FB] to-[#E9F2FB]">
      <Box className=" pb-0 pt-1 md:pt-3 md:pl-12 pl-1 md:h-auto h-[56px]">
        <Link
          href={APP_ROUTES(locale).HOME.to}
          className="cursor-pointer appbar-auth-logo-link"
          title="Home"
          aria-label="Home"
        >
          <Image
            src={image.cimigoLogo2}
            alt="cimigoLogo"
            width={150}
            height={48}
            loading="eager"
            className="md:w-auto md:h-auto h-[48px]"
          />
        </Link>
      </Box>
    </header>
  );
};

export default HeaderAuth;
